<template>
	<div :key="toUpdate" class="wrapper">
		<div v-if="field.type == 'image'" class="first">
			<el-upload
				class="upload-demo"
				action="#"
				:before-upload="onUploadImage"
				:before-remove="onDeleteImage"
				accept="image/jpeg,image/png"
				:limit="1"
				:file-list="fileList"
			>
				<el-button slot="trigger" size="small" type="primary">{{ $t("select-file") }}</el-button>
			</el-upload>
		</div>
		<div v-else-if="field.type == 'date'" class="first">
			<el-date-picker
				v-model="field.custom_field_value.value"
				type="date"
				@input="handleChange"
				format="dd/MM/yyyy"
				value-format="dd/MM/yyyy"
				:placeholder="field.rules.placeholder ? field.rules.placeholder : $t('pick-a-day')"
			>
			</el-date-picker>
		</div>

		<div v-else-if="field.type == 'text'" class="first">
			<el-input
				type="text"
				show-word-limit
				:disabled="(!superAdmin && disabled) || field.rules.computed_bool"
				:maxlength="field.rules.max"
				:minlegth="field.rules.min"
				v-model="field.custom_field_value.value"
				@input="handleChange"
				style="width: 100%"
				:placeholder="field.rules.placeholder ? field.rules.placeholder : field.name"
			>
				<i
					v-if="(superAdmin || (!superAdmin && !disabled)) && showEditPopover"
					class="el-icon-edit el-input__icon pointer-hover"
					slot="suffix"
					v-popover:popover
					@click="visiblePopOver = !visiblePopOver"
				>
				</i>
			</el-input>
		</div>

		<div v-else-if="field.type == 'long-text'" class="first">
			<el-input
				type="textarea"
				show-word-limit
				:disabled="(!superAdmin && disabled) || field.rules.computed_bool"
				:maxlength="field.rules.max"
				:minlegth="field.rules.min"
				v-model="field.custom_field_value.value"
				@input="handleChange"
				style="width: 100%"
				:placeholder="field.rules.placeholder ? field.rules.placeholder : field.name"
			>
				<i
					v-if="(superAdmin || (!superAdmin && !disabled)) && showEditPopover"
					class="el-icon-edit el-input__icon pointer-hover"
					slot="suffix"
					v-popover:popover
					@click="visiblePopOver = !visiblePopOver"
				>
				</i>
			</el-input>
		</div>

		<div v-else-if="field.type == 'number'" class="first">
			<el-input-number
				:disabled="(!superAdmin && disabled) || field.rules.computed_bool"
				v-model="field.custom_field_value.value"
				@input="handleChange"
				@blur="checkMinMax(field)"
				style="width: 100%"
				:min="field.rules.min"
				:max="field.rules.max"
				:step="field.rules.step"
				:precision="precision"
			/>
		</div>

		<div v-else-if="field.type == 'choice'" class="first">
			<el-select
				v-model="field.custom_field_value.value"
				@change="handleChange"
				:placeholder="field.rules.placeholder ? field.rules.placeholder : field.name"
				:disabled="(!superAdmin && disabled) || field.rules.computed_bool"
			>
				<el-option
					v-for="item in field.rules.list"
					:key="item"
					:value="item"
					:label="item.length > 60 ? item.substring(0, 60) + '...' : item"
				>
				</el-option>
			</el-select>
		</div>

		<div class="second">
			<el-tooltip v-if="!field.rules.nullable" class="item" :content="$t('required-field')" placement="top">
				<md-icon>star</md-icon>
			</el-tooltip>
		</div>

		<div class="second">
			<el-tooltip v-if="field.rules.tip" class="item" effect="dark" :content="field.rules.tip" placement="top">
				<md-icon>help</md-icon>
			</el-tooltip>
		</div>

		<el-popover
			ref="popover"
			placement="bottom"
			:title="`${$t('edit')} ${field.name}`"
			trigger="manual"
			v-model="visiblePopOver"
		>
			<p>{{ $t("edit-only-value") }}</p>
			<el-input
				:placeholder="field.rules.placeholder ? field.rules.placeholder : field.name"
				v-model="popoverValue"
				style="border: 1px solid #c0c4cc; border-radius: 4px"
			/>
			<p style="margin-top: 10px">{{ $t("new-computed-value") }}</p>
			<el-input :disabled="true" v-model="popoverComputedValue"></el-input>

			<div style="text-align: right; margin-top: 10px">
				<el-button size="mini" type="text" @click="visiblePopOver = !visiblePopOver">
					{{ $t("cancel") }}
				</el-button>
				<el-button type="primary" size="mini" @click="savePopover">{{ $t("save") }}</el-button>
			</div>
		</el-popover>
	</div>
</template>

<script>
import { mapGetters } from "vuex"
import { equalArrays } from "@/utils/utils"
import { getCustomFieldValue } from "@/utils/customfield"

export default {
	name: "field-type",
	props: ["field", "required", "level", "overrideSuperAdmin", "ownerId"],
	data() {
		return {
			disabled: undefined,
			fileList: [],
			computed_rules: undefined,
			visiblePopOver: false,
			popoverValue: "",
			popoverComputedValue: "",
			list: []
		}
	},
	computed: {
		...mapGetters({
			isSuperAdmin: "user/isSuperAdmin",
			toUpdate: "organization/toUpdate",
			settings: "modules/settings",
			owners: "compilation/owners"
		}),
		superAdmin() {
			if (this.overrideSuperAdmin) return false
			else return this.isSuperAdmin
		},
		readonly() {
			return this.field.rules.readonly
		},
		precision() {
			var precision = 0
			if (this.field.rules.step) {
				switch (this.field.rules.step) {
					case 1:
						precision = 0
						break
					case 0.1:
						precision = 1
						break
					case 0.01:
						precision = 2
						break
					case 0.001:
						precision = 3
						break
					default:
						precision = undefined
				}
			}

			return precision
		},
		showEditPopover() {
			if (!this.field.rules.computed_bool) return false

			var flag = false
			if (Array.isArray(this.field.rules.computed_rules)) {
				this.field.rules.computed_rules.forEach(rule => {
					if (rule[0] === "val") flag = true
				})
			}

			return flag
		}
	},
	async created() {
		if (this.field.type == "image" && this.field.custom_field_value) {
			if (this.field.custom_field_value.value) {
				var json = JSON.parse(this.field.custom_field_value.value)
				this.fileList.push({ name: json.og, url: "" })
			}
		}
		if (!this.field.custom_field_value) {
			this.field.custom_field_value = { value: "" }
			if (this.field.rules.readonly) {
				this.field.custom_field_value.value = this.field.rules.default
			}
		}
		this.disabled = (this.field.custom_field_value.value != "" && this.level == -1) || this.field.rules.readonly
		if (Array.isArray(this.field.rules.computed_rules)) {
			this.computed_rules = [...this.field.rules.computed_rules]
		} else {
			this.computed_rules = []
		}

		if (Array.isArray(this.field.rules.list)) {
			this.list = [...this.field.rules.list]
		} else {
			this.list = []
		}
		if (!this.field.custom_field_value.og) {
			this.field.custom_field_value.og = this.field.custom_field_value.value
		}
		if (this.field.rules.computed_bool) {
			await this.getCustomFieldValue(
				this.field.rules.computed_rules,
				this.settings,
				this.owners,
				this.field.custom_field_value.og
			).then(val => (this.field.custom_field_value.value = val))
		}

		this.popoverValue = this.field.custom_field_value.og
		if (this.field.custom_field_value.value) {
			await this.$emit("fillField", this.field.custom_field_value.value)
			await this.$emit(
				"setValue",
				this.showEditPopover ? this.field.custom_field_value.og : this.field.custom_field_value.value
			)
		}
	},
	methods: {
		equalArrays,
		getCustomFieldValue,
		handleChange: function () {
			this.$emit("focus", true)
			this.$emit("fillField", this.field.custom_field_value.value)
			this.$emit(
				"setValue",
				this.showEditPopover ? this.field.custom_field_value.og : this.field.custom_field_value.value
			)
		},
		onUploadImage: function (e) {
			this.fileList.push({ name: e.name, url: "" })
			this.$emit("image", e)
		},
		onDeleteImage: function (e) {
			this.fileList = []
			this.$emit("image", undefined)
		},
		checkMinMax: function (field) {
			var min = field.rules.min
			var max = field.rules.max
			if (field.custom_field_value.value < min) field.custom_field_value.value = min
			else if (field.custom_field_value.value > max) field.custom_field_value.value = max
			this.$emit("focus", true)
		},
		async savePopover() {
			this.field.custom_field_value.og = this.popoverValue
			if (this.field.rules.computed_bool) {
				await this.getCustomFieldValue(
					this.field.rules.computed_rules,
					this.settings,
					this.owners,
					this.field.custom_field_value.og
				).then(val => (this.field.custom_field_value.value = val))
			}

			this.visiblePopOver = !this.visiblePopOver
			this.handleChange()
		}
	},
	watch: {
		toUpdate: function () {
			this.disabled = (this.field.custom_field_value.value != "" && this.level == -1) || this.field.rules.readonly
		},
		readonly: function () {
			this.disabled = (this.field.custom_field_value.value != "" && this.level == -1) || this.field.rules.readonly
		},
		field: {
			handler(val, oldVal) {
				if (val.rules.computed_bool) {
					if (!this.equalArrays(val.rules.computed_rules, this.computed_rules)) {
						if (Array.isArray(val.rules.computed_rules)) this.computed_rules = [...val.rules.computed_rules]
						else this.computed_rules = []
						if (this.field.rules.computed_bool) {
							this.getCustomFieldValue(
								this.field.rules.computed_rules,
								this.settings,
								this.owners,
								this.field.custom_field_value.og
							).then(val => (this.field.custom_field_value.value = val))
						}
					}
				}
				if (Array.isArray(val.rules.list)) this.list = [...val.rules.list]
			},
			deep: true
		},
		popoverValue: function () {
			if (this.field.rules.computed_bool) {
				this.getCustomFieldValue(
					this.field.rules.computed_rules,
					this.settings,
					this.owners,
					this.popoverValue
				).then(val => (this.popoverComputedValue = val))
			}
		}
	}
}
</script>

<style scoped>
.upload-demo {
	margin-left: 10px;
}
.wrapper {
	overflow: hidden;
}
.first {
	width: 80%;
	float: left;
}
.second {
	padding: 8px 0 0 8px;
	overflow: hidden;
	float: left;
	margin: auto;
}
.pointer-hover {
	cursor: pointer !important;
}
</style>
